import { type FC } from 'react';
import { VStack } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import GuidanceBaseHelp from './Base/GuidanceBaseHelp';
import locales from './locales';

/**
 * Help-like guidance to explain how to draft the statutes
 */
const GuidanceStatutesDraft: FC = () => {
  const loc = locales.statutesHowTo;

  return (
    <GuidanceBaseHelp title={loc.title}>
      <VStack spacing="space-16">
        {loc.content.map((str) => (
          <Text color="inherit" fontSize="inherit" key={str}>
            {str}
          </Text>
        ))}
      </VStack>
    </GuidanceBaseHelp>
  );
};

export default GuidanceStatutesDraft;
